import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/img/logo.png'
import _imports_1 from '@/assets/img/slogin.png'
import _imports_2 from '@/assets/img/cwvip.jpg'
import _imports_3 from '@/assets/img/vipxq.jpg'
import _imports_4 from '@/assets/img/xstxico1.png'


const _hoisted_1 = { class: "header-container" }
const _hoisted_2 = { class: "header-right" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "header-right-img",
  src: _imports_4
}
const _hoisted_5 = {
  class: "el-dropdown-link",
  style: {"cursor":"pointer"}
}
const _hoisted_6 = { class: "header-info" }
const _hoisted_7 = { class: "header-info-top" }
const _hoisted_8 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 1,
  class: "header-info-avatar",
  src: _imports_4
}
const _hoisted_11 = { class: "header-info-name" }
const _hoisted_12 = { class: "name" }
const _hoisted_13 = { class: "time" }
const _hoisted_14 = { class: "vip" }
const _hoisted_15 = { class: "header-vip-time" }
const _hoisted_16 = { class: "num" }
const _hoisted_17 = { class: "num" }
const _hoisted_18 = { class: "num" }
const _hoisted_19 = {
  key: 0,
  class: "header-buy"
}
const _hoisted_20 = { class: "header-tap" }
const _hoisted_21 = { class: "header-loginout" }
const _hoisted_22 = { class: "popup-inner grade-inner" }
const _hoisted_23 = { class: "grade-inner-box" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "grade-inner-box" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "dialog-footer" }

import userInfoDialog from "./userInfoDialog.vue"
import policyDialog from "./policyDialog.vue"
import privacyDialog from "./privacyDialog.vue"
import feedbackDialog from "./feedbackDialog.vue"
import purchaseDialog from "./purchaseDialog.vue"
import { getUserInfo, getUserList, setUser, getDict } from "@/api/common.js"
import { ref, reactive, onMounted, computed, watch } from 'vue';
import { useStore } from "vuex"
import { useRouter } from 'vue-router';
import { ElMessage } from 'element-plus'

export default /*@__PURE__*/_defineComponent({
  __name: 'layoutHeader',
  setup(__props) {

const router = useRouter();
const store = useStore();
const gradeList = ref([])
const sessionList = [
    '上学期',
    '下学期'
]
const popupShow = ref(false)
const userShow = ref(false)
const userInfoShow = ref(false)
const policyShow = ref(false)
const privacyShow = ref(false)
const feedShow = ref(false)
const purchaseShow = ref(false)
const purchaseType = ref('')
const userInfo = computed(() => store.state.userInfo);
const isVip = userInfo.value.vipEndDate ? true : false
const grade = computed(() => store.state.grade)
const term = computed(() => store.state.term)
const gradeActive = ref('')
const termActive = ref('')
const userList = ref([])

watch([grade, term],
    ([newGrade, newTerm], [oldGrade, oldTerm]) => {
        gradeActive.value = newGrade;
        termActive.value = newTerm;
    },
    { flush: 'sync',immediate: true }
);

function wxpaySuccess() {
    purchaseShow.value = false
    router.go(0)
}
function loginEvent() {
    store.dispatch('setLoginFlag')
}
function gradeClick(item) {
    gradeActive.value = item;
}
function termClick(item) {
    termActive.value = item;
}
function popupConfirm() {
    popupShow.value = false
    if (gradeActive.value != grade.value || termActive.value != term.value) {
        store.dispatch('setGradeTerm', {
            grade: gradeActive.value,
            term: termActive.value
        })
        router.go(0)
    }
}
function loginOut() {
    sessionStorage.setItem('token', '')
    store.dispatch('setLogin', {});
    store.dispatch('setGradeTerm', {
        grade: '三年级',
        term: '上学期'
    })
    router.replace({ path: '/composition/teaching' }).then(() => {
        location.reload()
    })
}
function openPurchase(type: string) {
    purchaseType.value = type;
    purchaseShow.value = true;
}
function openPerson() {
    if (userShow.value) {
        userShow.value = false
    } else {
        getUserInfo().then(res => {
            store.dispatch('setLogin', res.data);
            store.dispatch('setGradeTerm', {
                grade: res.data.grade || '三年级',
                term: res.data.term || '上学期'
            })
            userShow.value = true
        })
    }
}
function dropdownCommand(item) {
    setUser(item.userId).then(res => {
        ElMessage.success('切换成功！')
        sessionStorage.setItem('token', res.data)
        getUserInfo().then(res => {
            store.dispatch('setLogin', res.data);
            store.dispatch('setGradeTerm', {
                grade: res.data.grade || '三年级',
                term: res.data.term || '上学期'
            })
            router.go(0)
        })
    })
}
function getDictList() {
    getDict({
        dicCode: 'dd_grade'
    }).then(res => {
        gradeList.value = (res.data || []).map(item => {
            return item.dicItemName
        })
    })
}
function getUser() {
    getUserList().then(res => {
        userList.value = res.data || []
    })
}
onMounted(() => {
    getUser()
    getDictList()
})

return (_ctx: any,_cache: any) => {
  const _component_ArrowDown = _resolveComponent("ArrowDown")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_Setting = _resolveComponent("Setting")!
  const _component_Switch = _resolveComponent("Switch")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[27] || (_cache[27] = _createStaticVNode("<div class=\"header-left\" data-v-b3e5471a><div class=\"logo-img\" data-v-b3e5471a><img src=\"" + _imports_0 + "\" data-v-b3e5471a></div><div class=\"slogin-img\" data-v-b3e5471a><img src=\"" + _imports_1 + "\" data-v-b3e5471a></div></div>", 1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "header-right-tip",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (popupShow.value=true))
      }, [
        _createElementVNode("span", null, "当前年级：" + _toDisplayString(grade.value) + _toDisplayString(term.value), 1),
        _createVNode(_component_el_icon, null, {
          default: _withCtx(() => [
            _createVNode(_component_ArrowDown)
          ]),
          _: 1
        })
      ]),
      (userInfo.value.userId && !_unref(isVip))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "vip-btn",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (openPurchase('vip') ))
          }, _cache[16] || (_cache[16] = [
            _createElementVNode("img", { src: _imports_2 }, null, -1)
          ])))
        : _createCommentVNode("", true),
      (userInfo.value.userId && _unref(isVip))
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "vip-btn",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (openPurchase('vip') ))
          }, _cache[17] || (_cache[17] = [
            _createElementVNode("img", { src: _imports_3 }, null, -1)
          ])))
        : _createCommentVNode("", true),
      (userInfo.value.userId)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: "header-right-tip",
            onClick: openPerson
          }, [
            (userInfo.value.avatarUrl)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "header-right-img",
                  src: userInfo.value.avatarUrl
                }, null, 8, _hoisted_3))
              : (_openBlock(), _createElementBlock("img", _hoisted_4)),
            _createElementVNode("span", null, _toDisplayString(userInfo.value.userName || userInfo.value.userPhone), 1),
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_component_Setting)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (!userInfo.value.userId)
        ? (_openBlock(), _createElementBlock("div", {
            key: 3,
            class: "header-right-tip",
            onClick: loginEvent
          }, [
            _cache[18] || (_cache[18] = _createElementVNode("span", null, "您还未登录", -1)),
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_component_Setting)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (userList.value.length)
        ? (_openBlock(), _createBlock(_component_el_dropdown, {
            key: 4,
            class: "dropdown-box",
            placement: "bottom-end",
            trigger: "click",
            onCommand: dropdownCommand
          }, {
            dropdown: _withCtx(() => [
              _createVNode(_component_el_dropdown_menu, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userList.value, (item) => {
                    return (_openBlock(), _createBlock(_component_el_dropdown_item, {
                      key: item.studentId,
                      command: item
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.studentName || item.studentAdminPhone), 1)
                      ]),
                      _: 2
                    }, 1032, ["command"]))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_5, [
                _cache[19] || (_cache[19] = _createTextVNode(" 切换学生 ")),
                _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Switch)
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: userShow.value,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((userShow).value = $event)),
      "append-to-body": "",
      "show-close": false,
      top: "40px",
      class: "custom-dialog",
      "modal-class": "custom-modal-dialog"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              (userInfo.value.avatarUrl)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: "header-info-avatar",
                    src: userInfo.value.avatarUrl
                  }, null, 8, _hoisted_9))
                : (_openBlock(), _createElementBlock("img", _hoisted_10)),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("span", _hoisted_12, _toDisplayString(userInfo.value.userName || userInfo.value.userPhone), 1)
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_13, [
                  _withDirectives(_createElementVNode("span", _hoisted_14, "VIP会员", 512), [
                    [_vShow, _unref(isVip) ]
                  ]),
                  _createElementVNode("span", null, _toDisplayString(userInfo.value.vipEndDate) + " 到期", 1)
                ], 512), [
                  [_vShow, _unref(isVip) ]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_16, _toDisplayString(userInfo.value.aiCallRestNum || 0), 1),
              _cache[20] || (_cache[20] = _createElementVNode("div", null, "AI调用余额", -1))
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_17, _toDisplayString(userInfo.value.vipRestNum || 0), 1),
              _cache[21] || (_cache[21] = _createElementVNode("div", null, "VIP剩余天数", -1))
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_18, _toDisplayString(userInfo.value.aiCallNum || 0), 1),
              _cache[22] || (_cache[22] = _createElementVNode("div", null, "AI调用次数", -1))
            ])
          ]),
          (userInfo.value.userId && _unref(isVip) )
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createElementVNode("div", {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (openPurchase( 'vip') ))
                }, "VIP续期"),
                _createElementVNode("div", {
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (openPurchase( 'ai') ))
                }, "AI购买次数")
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", {
              onClick: _cache[5] || (_cache[5] = ($event: any) => (userInfoShow.value=true ))
            }, "个人中心"),
            _createElementVNode("div", {
              onClick: _cache[6] || (_cache[6] = ($event: any) => (feedShow.value=true ))
            }, "意见反馈"),
            _createElementVNode("div", {
              onClick: _cache[7] || (_cache[7] = ($event: any) => (policyShow.value=true ))
            }, "用户协议"),
            _createElementVNode("div", {
              onClick: _cache[8] || (_cache[8] = ($event: any) => (privacyShow.value=true ))
            }, "隐私政策")
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_el_button, {
              color: "#ef8b25 ",
              class: "footer-btn1",
              onClick: loginOut 
            }, {
              default: _withCtx(() => _cache[23] || (_cache[23] = [
                _createTextVNode("退出登陆")
              ])),
              _: 1,
              __: [23]
            }, 8, ["onClick"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: popupShow.value ,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((popupShow).value = $event)),
      title: "年级选择 ",
      width: "400px ",
      center: ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_27, [
          _createVNode(_component_el_button, {
            color: "#ef8b25 ",
            class: "footer-btn1",
            onClick: popupConfirm 
          }, {
            default: _withCtx(() => _cache[26] || (_cache[26] = [
              _createTextVNode("确定选择")
            ])),
            _: 1,
            __: [26]
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_22, [
          _cache[24] || (_cache[24] = _createElementVNode("div", { class: "grade-inner-title" }, "年级", -1)),
          _createElementVNode("div", _hoisted_23, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gradeList.value, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item ,
                class: _normalizeClass([ 'grade-inner-item',gradeActive.value==item? 'active': ''] ),
                onClick: ($event: any) => (gradeClick(item) )
              }, _toDisplayString(item), 11, _hoisted_24))
            }), 128))
          ]),
          _cache[25] || (_cache[25] = _createElementVNode("div", { class: "grade-inner-title" }, "学期", -1)),
          _createElementVNode("div", _hoisted_25, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(sessionList, (item) => {
              return _createElementVNode("div", {
                key: item ,
                class: _normalizeClass([ 'grade-inner-item',termActive.value==item? 'active': ''] ),
                onClick: ($event: any) => (termClick(item) )
              }, _toDisplayString(item), 11, _hoisted_26)
            }), 64))
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (userInfoShow.value )
      ? (_openBlock(), _createBlock(userInfoDialog, {
          key: 0,
          popupShow: userInfoShow.value ,
          onClose: _cache[11] || (_cache[11] = ($event: any) => (userInfoShow.value=false ))
        }, null, 8, ["popupShow"]))
      : _createCommentVNode("", true),
    (policyShow.value )
      ? (_openBlock(), _createBlock(policyDialog, {
          key: 1,
          popupShow: policyShow.value ,
          onClose: _cache[12] || (_cache[12] = ($event: any) => (policyShow.value=false ))
        }, null, 8, ["popupShow"]))
      : _createCommentVNode("", true),
    (privacyShow.value )
      ? (_openBlock(), _createBlock(privacyDialog, {
          key: 2,
          popupShow: privacyShow.value ,
          onClose: _cache[13] || (_cache[13] = ($event: any) => (privacyShow.value=false ))
        }, null, 8, ["popupShow"]))
      : _createCommentVNode("", true),
    (feedShow.value )
      ? (_openBlock(), _createBlock(feedbackDialog, {
          key: 3,
          popupShow: feedShow.value ,
          onClose: _cache[14] || (_cache[14] = ($event: any) => (feedShow.value=false ))
        }, null, 8, ["popupShow"]))
      : _createCommentVNode("", true),
    (purchaseShow.value )
      ? (_openBlock(), _createBlock(purchaseDialog, {
          key: 4,
          popupShow: purchaseShow.value ,
          type: purchaseType.value ,
          onClose: _cache[15] || (_cache[15] = ($event: any) => (purchaseShow.value=false )),
          onWxpaySuccess: wxpaySuccess
        }, null, 8, ["popupShow", "type"]))
      : _createCommentVNode("", true)
  ]))
}
}

})